import axios, { secondAxios } from "../../../../../../api/axios";
import { createTask as createPlantTask } from "../../../../Project/plant/PlantTaskPage/TaskList/api";
import { createTask as createProjectTask } from "../../ProjectsPage/ProjectTaskPage/TaskList/api";

export const getSchedule = async (projectId) => {
  const { data } = await secondAxios.get("schedule4d/" + projectId);
  return data;
};

export const updateSchedule = async (body) => {
  const { data } = await secondAxios.patch("schedule4d", body);
  return data;
};
export const update4D = async (id, body, accessToken) => {
  const payload = { id, ...body };
  if (Object.prototype.hasOwnProperty.call(body, "resourceId")) {
    payload.resourceId =
      body.resourceId === "" || body.resourceId === undefined
        ? null
        : body.resourceId;
  }
  const { data } = await secondAxios.patch(`task/${id}`, payload, {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });
  return data;
};

export const getTrackItem = async (raciId) => {};

export const getProjectData = async (projectId, accessToken) => {
  const resp = await secondAxios.get("task/all/" + projectId, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  console.log("tasksssss", resp);
  return resp.data;
};

export const getPlantData = async (plantId, accessToken) => {
  console.log('heres',plantId);
  
  const resp = await secondAxios.get("task/all/plant/" + plantId, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  console.log("plant tasks", resp);
  return resp.data;
};

/**
 * Create a 4D schedule task linked either to a project or a plant.
 * Delegates to existing task creation APIs.
 */
export const create4DTask = async ({
  task,
  projectId,
  plantId,
  accessToken,
}) => {
  // if (!accessToken) {
  //   throw new Error("Missing access token for create4DTask");
  // }

  // Normalize payload: ensure taskCode and estimatedTime exist
  const payload = {
    ...task,
    taskCode: task.taskCode || "",
    estimatedTime: Number(task.estimatedTime) || 0,
  };
  if (Object.prototype.hasOwnProperty.call(task, "resourceId")) {
    payload.resourceId =
      task.resourceId === "" || task.resourceId === undefined
        ? null
        : task.resourceId;
  }

  if (plantId) {
    return await createPlantTask({
      task: payload,
      plantId,
      accessToken,
    });
  }

  if (projectId) {
    return await createProjectTask({
      task: payload,
      projectId,
      accessToken,
    });
  }

  throw new Error("create4DTask requires either projectId or plantId");
};

// export const update = async (data) => {
//   const updateTaskApi = "pms/update";
//   console.log("updating", data)
//   return await axios.post(updateTaskApi, data)
// }

// export const refresh = async (equipId) => {
//   const refreshTaskApi = "pms/refresh/" + equipId;
//   return await axios.get(refreshTaskApi)
// }
